module.exports = __webpack_public_path__ + "static/img/trafficActivitiesSuccess.0de12bd.png";